var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-group"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":_vm.modificar}},[_vm._v("Modificar")]),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.eliminar}},[_vm._v("Eliminar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }